import React from 'react';
import classNames from 'classnames';
import { getSlugUrl } from '../utils';

const LanguageSelectorItem = props => {
    const {
        language_name,
        language_tag,
        current_language_tag,
        alternate_slug,
        baseLink,
        orgLink,
        handleItemKeyDown
    } = props;
    const isCurrentLanguage = language_tag === current_language_tag;
    const itemClass = classNames({ 'active': isCurrentLanguage });
    const itemUrl = isCurrentLanguage ? baseLink : getSlugUrl(orgLink, alternate_slug);
    return (
        <li>
            <a href={itemUrl}
                className={itemClass}
                aria-selected={isCurrentLanguage}
                role="option"
                onKeyDown={handleItemKeyDown}
            >{language_name}
            </a>
        </li>
    );
};

export default LanguageSelectorItem;



// WEBPACK FOOTER //
// ./components/navigation/language_selector_item.jsx